
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>B.Com (Honors) </h1>
                </div>
            </div>
        </div>          
    </div>  
</section>    

<section class="section-lg std-scholarship">
    <div class="container">
        <div class="row row-50">
            <div class="col-md-3">
                <div class="vertical-tabs">
                    <ul class="nav nav-pills flex-column" id="myTab" role="tablist"> 
                        <li class="nav-item">
                            <a class="nav-link active" id="tab7-tab" data-toggle="tab" href="#tab7" role="tab" aria-controls="tab7" aria-selected="true">Overview  </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab1-tab" data-toggle="tab" href="#tab1" role="tab" aria-controls="tab1" aria-selected="true">Eligibility Criteria </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab2-tab" data-toggle="tab" href="#tab2" role="tab" aria-controls="tab2" aria-selected="false">Duration</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab3-tab" data-toggle="tab" href="#tab3" role="tab" aria-controls="tab3" aria-selected="false">Subjects</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab4-tab" data-toggle="tab" href="#tab4" role="tab" aria-controls="tab4" aria-selected="false">Affiliation</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab5-tab" data-toggle="tab" href="#tab5" role="tab" aria-controls="tab5" aria-selected="false">Scope  and Prospects</a>
                        </li>
                        <!-- <li class="nav-item">
                            <a class="nav-link" id="tab6-tab" data-toggle="tab" href="#tab6" role="tab" aria-controls="tab6" aria-selected="false">Fees And Intake</a>
                        </li> -->
                    </ul>
                </div>
            </div>
            <div class="col-md-9">
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="tab7" role="tabpanel" aria-labelledby="tab7-tab">
                        <div class="inner-title"  >
                            <h3>Overview</h3>                           
                           
                        </div>
                        <div class="text-left">
                            <p>B.Com (Honors ) is a 3 years professional Undergraduate Industry-oriented degree programme that teaches students about business, accounting, marketing, and other related subjects. This course will be extremely helpful to those who wish to work in corporate administration or the business sector.</p>
                            <p>G H Raisoni College of Commerce, Science, and Technology is one of the best commerce colleges in Nagpur, Maharashtra that offers B.Com.(Honors) course for students.</p>
                        </div>
                    </div>

                    <div class="tab-pane fade " id="tab1" role="tabpanel" aria-labelledby="tab1-tab">
                        <div class="inner-title"  >
                            <h3>Eligibility Criteria   </h3>                           
                           
                        </div>
                    
                            <p>For the BCOM-HONORS 1 st Semester:</p>
                            <ul class="list-item"> 
                                <li>The Candidate needs to have Passed the 12th Standard Examination of the Maharashtra State Board of Secondary and Higher Secondary Education, with English at Higher or Lower level .</li>
                                <li>12th  Standard Examination of Maharashtra State Board of Secondary and Higher Secondary Education in Vocational Stream with one language only.</li>
                                <li>Any other Equivalent Examination of any State in (10+2) pattern with any combination of subjects. A migration certificate is required for candidates applying from other states.</li>
                              </ul>
                    </div>

                    <div class="tab-pane fade" id="tab2" role="tabpanel" aria-labelledby="tab2-tab">                                
                        <div class="inner-title"  >
                            <h3>Duration
                            </h3>
                           
                        </div>  
                        <div class="text-left">                        
                            <p>3 Years – (6 Semesters)</p>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab3" role="tabpanel" aria-labelledby="tab3-tab">                                
                        <div class="inner-title"  >
                            <h3>Subjects
                            </h3>
                           
                        </div>
                         <p>4/5 subjects per semester </p>

                         <ul class="list-item link-list">
							<li><a href="https://drive.google.com/file/d/1uSyp_XPsQlTowGfkiNrM05nwagyVK5in/view?usp=sharing" target="_blank" >B.Com (Honors)</a></li>
							
						</ul> 
                    </div>
                    <div class="tab-pane fade" id="tab4" role="tabpanel" aria-labelledby="tab4-tab">                                
                        <div class="inner-title"  >
                            <h3>Affiliation
                            </h3>
                           
                        </div> 
                        <div class="text-left">                         
                            <p>RTM Nagpur University, Nagpur </p>
                        </div> 
                    </div>
                    <div class="tab-pane fade" id="tab5" role="tabpanel" aria-labelledby="tab5-tab">                                
                        <div class="inner-title"  >
                            <h3>Scope  and Prospects
                            </h3>
                           
                        </div> 
                      
                            <p><strong>Scope :</strong> After completing a B.Com(Honors) degree from the best commerce college in Nagpur, students have various choices to go for further study. Here are some options a student can choose for the following study:</p>

                                    <ul class="list-item ml-5 mb-3">
                                        <li>Charted Accountant </li>
                                        <li>Company Secretary </li>
                                        <li>B.Ed. </li> 
                                        <li>M.Com. </li>
                                        <li>MBA  </li>
                                        <li>MCM</li>
                                        <li>Entrepreneurship </li>
                                    </ul>
                            <p><strong> Prospects :</strong> Students who finish their B.Com.(Honors ) degree from GHRCCST one of the
                                best commerce colleges in Maharashtra have bestowed management abipties and can
                                consequently pursue up management profession. It opens doors for students in various
                                private as well as government job areas.</p>
                                <div>
                                    <ul class="list-item ml-5 mb-3">
                                        <li>Finance Risk Manage  </li>
                                        <li>Business Analyst</li>
                                        <li>Banks, Financial Services and Insurance (BFSI) Sector </li> 
                                        <li>Business Consultancy </li>
                                        <li>Money and Accounting </li>
                                        <li>Investment Banking</li>
                                    </ul>
                                </div>   
                    </div>
                 
                    <!-- <div class="tab-pane fade" id="tab6" role="tabpanel" aria-labelledby="tab6-tab">                                
                        <div class="inner-title"  >
                            <h3>Fees And Intake
                            </h3>
                           
                        </div> 
                        <ul class="list-item"> 
                            <li><strong>Fees  :</strong> : Rs 25,000 per year</li>
                            <li><strong>Intake :</strong>: 60 students  </li>
                        </ul>
                    </div>   -->
            
                <div class="text-center mt-5">
                    <a class="button-text" href="https://raisoni.nopaperforms.com/rgi" target="_blank">Apply Now</a>
                </div>
                </div>
            </div>
        </div>
    </div>    
</section>

